var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavTop'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permit row"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/images/renliziyuanxukezheng.png")}})])
}]

export { render, staticRenderFns }